const Footer = () => (
  <footer
    data-testid="footer"
    className="py-12 bg-white border-t border-[#E7E5E4] text-xs font-mono-ui text-stone-500"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2">
        <span className="font-bold text-stone-900 font-serif-display text-sm">Brim.</span>
        <span>© 2025 Brim Technologies Inc.</span>
      </div>
      <div className="flex gap-6">
        <a href="#how-it-works" data-testid="footer-protocol-link" className="hover:text-stone-900 transition-colors">
          System Protocol
        </a>
        <a href="#interest-form" data-testid="footer-request-access-link" className="hover:text-stone-900 transition-colors">
          Request Access
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
